import { IAuthorizedInstallerRequest } from '@authorizedInstaller/types/authorizedInstallers';
import { PaginationProps, PaginationReturn } from '@common/types/service';
import { api } from '@services/api';
import { getFilterString, getPaginationString } from '@utils/service';

const authorizedInstallerApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAuthorizedInstallerRequests: builder.query<PaginationReturn<IAuthorizedInstallerRequest>, PaginationProps>({
            query: ({ filters, ...pagination }) =>
                `authorized-installer-program/overview?${getPaginationString(pagination)}${
                    filters ? getFilterString(filters) : ''
                }`,
            providesTags: ['AuthorizedInstallerRequests'],
        }),
        acceptAuthorizedInstallerRequest: builder.mutation<void, number>({
            query: (id) => ({
                url: `authorized-installer-program/request/${id}/accept`,
                method: 'PUT',
            }),
        }),
        rejectAuthorizedInstallerRequest: builder.mutation<void, number>({
            query: (id) => ({
                url: `authorized-installer-program/request/${id}/reject`,
                method: 'PUT',
            }),
        }),
        saveApplication: builder.mutation<void, FormData>({
            query: (body) => ({
                url: 'authorized-installer-program/request/',
                body,
                method: 'POST',
            }),
            invalidatesTags: ['AIPApplications'],
        }),
    }),
});

export const {
    useGetAuthorizedInstallerRequestsQuery,
    useAcceptAuthorizedInstallerRequestMutation,
    useRejectAuthorizedInstallerRequestMutation,
    useSaveApplicationMutation,
} = authorizedInstallerApi;
export default authorizedInstallerApi;
